export default "__VITE_ASSET__Bon74VYM__"